import React from 'react';
import MainLayout from '../../../../Components/CommonComponents/Layout/mainLayout';
import JobsViewDetailsContainer from './../../../../Containers/UserContainer/Jobs/ViewDetails/index';
const JobsViewDetailsScreen = () => {
  return <JobsViewDetailsContainer />;
};

export default JobsViewDetailsScreen;
